import { useTranslation } from 'react-i18next';
import portrait from './../medias/marie-baudlot.jpg';
import cvProductFr from './../medias/CV_Marie_Baudlot_Product_FR.pdf';
import cvProductEn from './../medias/CV_Marie_Baudlot_Product_EN.pdf';
import cvFrontFr from './../medias/CV_Marie_Baudlot_Front-dev_FR.pdf';
import cvFrontEn from './../medias/CV_Marie_Baudlot_Front-dev_EN.pdf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-regular-svg-icons'

const Presentation = () => {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  return (
    <div className='presentation'>
      <img className='portrait' src={portrait} alt="Marie Baudlot" />
      <h2 className='underline-title'>{t('whoami.title')}</h2>
      <p>{t('whoami.text')}</p>
      <p>{t('whoami.text2')}</p>
      <div className='link-container'>
        <a className='btn-link' href={isEn ? cvProductEn : cvProductFr} download>
          <FontAwesomeIcon icon={faFilePdf} />{t('whoami.downloadProduct')}
        </a>
        <a className='btn-link' href={isEn ? cvFrontEn : cvFrontFr} download>
          <FontAwesomeIcon icon={faFilePdf} />{t('whoami.downloadFront')}
        </a>
      </div>
    </div>
  );
};

export default Presentation;
